import { render, staticRenderFns } from "./img-empty.vue?vue&type=template&id=42918b82&"
import script from "./img-empty.vue?vue&type=script&lang=js&"
export * from "./img-empty.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/builds/MWmsPKDH/0/framework/qmai-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('42918b82')) {
      api.createRecord('42918b82', component.options)
    } else {
      api.reload('42918b82', component.options)
    }
    module.hot.accept("./img-empty.vue?vue&type=template&id=42918b82&", function () {
      api.rerender('42918b82', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "packages/empty/src/img-empty.vue"
export default component.exports